// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5b0f8f34","268":"b0673056","292":"8eb9dd3b","455":"286be43c","484":"a79bc8bf","502":"48644370","551":"7bfa61bd","828":"cc225078","842":"56eb3448","851":"a726c271"}[chunkId] + ".chunk.js";
};